
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lettersfromesther",
      function () {
        return require("private-next-pages/lettersfromesther.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lettersfromesther"])
      });
    }
  